import { LoadingBarService } from '@ngx-loading-bar/core';
import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { environment } from '@env/environment';
import { svgIconList } from '@shared/svg-icon-list';
import { SystemSettingHttpService } from '@core/services/system-setting-http.service';
import { MaintenanceHttpService } from '@core/services/maintenance-http.service';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-maintenance',
  imports: [CommonModule, TranslateModule, SafeHtmlPipe],
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  returnDateTime: string;
  sitePrefix = environment.sitePrefix.toLocaleLowerCase();
  siteName = environment.siteName.toUpperCase();
  languageCode = localStorage.getItem('language_code')?.toLowerCase();
  countryCode = localStorage.getItem('country_code')?.toLowerCase();
  svg: any = svgIconList;

  constructor(
    private loadingBarService: LoadingBarService,
    private systemSettingHttpService: SystemSettingHttpService,
    private maintenanceHttpService: MaintenanceHttpService
  ) { }

  ngOnInit() {
    this.loadingBarService.complete();
    // End-maintenance time is held by MaintenanceHttpService (+ SSR TransferState) in this app, not localStorage.
    this.returnDateTime = moment(this.maintenanceHttpService.getEndDateTime()).local(true).format('HH:mm');
    this.removeMaintenace();
  }

  removeMaintenace() {
    this.systemSettingHttpService.getMaintenance().subscribe(() => {
      window.location.href = '/';
    });
  }

  getGMTOffset(): string {
    const offset = -new Date().getTimezoneOffset(); // Convert to positive for correct GMT format
    const hours = offset / 60;
    const sign = hours >= 0 ? '+' : '-';
    return `GMT${sign}${Math.abs(hours)}`;
  }

  redirectToLiveChat() {
    window.location.href = 'https://go.crisp.chat/chat/embed/?website_id=a1a7b27b-3d0f-45fb-8d7f-93ca6cd32831';  
  }

  redirectToLogin() {
    window.location.href = 'https://bwina888.com/login';  
  }
}
